import React, { ReactElement, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useSuccessMessageContext } from '../../../../context/SuccessMessageContext';
import { useClient, useClientStatusContext } from '../../../../context/ClientStatusContext';
import routes from '../../../../routing/routes';
import useFieldErrorMessages from '../../../useFieldErrorMessages';
import { updateTerminDoktrinalneDefinicie } from '../../../../client/termin/terminDoktrinalneDefinicieUpdateClient';
import Definicia from '../../../../model/Definicia';
import DoktrinalneDefinicieUpdateForm from './component/DoktrinalneDefinicieUpdateForm';
import { technickePricinyErrorStatus } from '../../../../constants/ErrorConstant';

interface Props {
  initialDefinicie: Array<Definicia>;
}

const DoktrinalneDefinicieUpdate = ({ initialDefinicie }: Props): ReactElement => {
  const [doktrinalneDefinicie, setDoktrinalneDefinicie] = useState(initialDefinicie);
  const { tezaurusUuid, terminUuid } = useParams<{ tezaurusUuid: string, terminUuid: string }>();

  const {
    wrapClient: terminDoktrinalneDefinicieUpdateClient,
    status: updateTerminStatus,
  } = useClient(updateTerminDoktrinalneDefinicie);

  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();
  const { handleStatus } = useClientStatusContext();
  const {
    getFieldErrorMessage,
    clearFieldErrorMessage,
    clearAllFieldErrorMessages,
  } = useFieldErrorMessages();

  const handleSubmit = async (event): Promise<void> => {
    event.preventDefault();
    await terminDoktrinalneDefinicieUpdateClient(terminUuid, doktrinalneDefinicie);
    navigate(routes.tezaurus.admin.termin.detail.withParams(tezaurusUuid, terminUuid));
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  useEffect(() => {
    if (updateTerminStatus?.responseCode === 404) {
      handleStatus(technickePricinyErrorStatus);
    }
  }, [updateTerminStatus, handleStatus]);

  return (
    <DoktrinalneDefinicieUpdateForm
      doktrinalneDefinicie={doktrinalneDefinicie}
      setDoktrinalneDefinicie={setDoktrinalneDefinicie}
      onSubmit={handleSubmit}
      getFieldErrorMessage={getFieldErrorMessage}
      clearFieldErrorMessage={clearFieldErrorMessage}
      clearAllFieldErrorMessages={clearAllFieldErrorMessages}
      loading={updateTerminStatus.loading}
    />
  );
};

export default DoktrinalneDefinicieUpdate;
